import { createSlice, createAsyncThunk, type PayloadAction } from "@reduxjs/toolkit";
import { getAllJobs } from "@/api/misc";

type Job = any;

interface JobsState {
  allJobs: Job[];
}

const initialState: JobsState = {
  allJobs: [],
};

// Async thunk for getting jobs
export const getJobsAction = createAsyncThunk(
  "job/getJobs",
  async (organizationData: { id: string }, { rejectWithValue }) => {
    try {
      const response = await getAllJobs(organizationData.id);
      return response.data.jobs;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    addJob: (state, action: PayloadAction<Job>) => {
      state.allJobs.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobsAction.fulfilled, (state, action: PayloadAction<Job[]>) => {
      state.allJobs = action.payload;
    });
    // Handle other states like pending, rejected if needed
  },
});

export const { addJob } = jobSlice.actions;

export default jobSlice.reducer;
